import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ValorationPage } from './valoration.page';

const routes: Routes = [
  {
    path: '',
    component: ValorationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ValorationPageRoutingModule {}
